namespace Riepiloghi.Administration {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}

